<div class="col formscreen">
    <div class="w100 align-start justify-start">
        <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
    </div>
    <div class="grow-1 col align-center justify-center">
        <form class="loginform" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="col headline">
                <h1>Welcome</h1>
                <span>Login into your <strong>account</strong></span>
            </div>
            <rr-input
                label="Email"
                type="email"
                [required]="true"
                [FormControl]="$any(loginForm.controls['email'])"
            ></rr-input>
            <div class="col withlink tiny">
                <rr-input
                    label="Password"
                    type="password"
                    [required]="true"
                    [FormControl]="$any(loginForm.controls['password'])"
                ></rr-input>
                <a href="/login/resetpassword">Forgot password?</a>
            </div>
            <rr-btn type="Primary" (btnClick)="onSubmit()">Log in</rr-btn>
            <div class="row gap-8 tiny align-center space-between signin">
                <span>Don't have an account?</span>
                <rr-btn
                    routerLink="/login/register"
                    type="Secondary"
                    size="Small"
                    >Sign up</rr-btn
                >
            </div>
            <rr-divider></rr-divider>
            <rr-disclaimer
                [type]="disclaimerType"
                [showIcon]="false"
            ></rr-disclaimer>
        </form>
    </div>
    <rr-disclaimer
        [type]="disclaimerTypeFooter"
        [showIcon]="false"
    ></rr-disclaimer>
</div>
<div class="rightsideimage"></div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
